// @flow

import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router'
import { history } from './router/index';

import map from '@adactive/arc-map/src/MapReducers';
import type { MapReducerStateType } from '@adactive/arc-map/src/initialState';

import loadingScreen from '@adactive/arc-loading-screen/src/LoadingScreenReducer';
import { WayFindingControlsReducers } from '@adactiveasia/adasia-wayfindingcontrols';
import type { LoadingScreenReducerType } from '@adactive/arc-loading-screen/src/LoadingScreenReducer';

export type RoutingReducerType = {|
    location: {|
        pathname: string,
        search: string,
        hash: string,
    |}
|};

export type AppStateType = {|
    router: RoutingReducerType,
    map: MapReducerStateType,
    loadingScreen: LoadingScreenReducerType,
|};

const appState: AppStateType = {
    router: connectRouter(history),
    map,
    loadingScreen,
    wayFindingControls: WayFindingControlsReducers
};

export default combineReducers(appState);



// WEBPACK FOOTER //
// ./src/rootReducer.js